<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>loading</h5>
        <br>
          <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <div v-if="wineryExists">
        <b-container fluid style="padding:0">
          <b-row>
            <b-col sm="12" style="padding:0" align="center">
              <div class="carousel-wrapper">          
                <div class="language">
                  <template>
                    <b-dropdown left split text="language" 
                      class="language-dropdown-white" 
                      toggle-class="toggle-language-white" 
                      split-class="split-language-white" 
                      style="font-size: 12px;"
                    >
                  <template #button-content>
                    <img
                      :src="currentLanguageFlag"
                      style="width:28px; height:19px; border-radius:2px;"
                    >
                  </template>

                      <!-- Dropdown Items -->
                      <b-dropdown-item @click="selectLanguage('en')">
                        <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                        English
                      </b-dropdown-item>
                      <b-dropdown-item @click="selectLanguage('fr')">
                        <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                        Français (French)
                      </b-dropdown-item>
                      <b-dropdown-item @click="selectLanguage('de')">
                        <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                        Deutsch (German)
                      </b-dropdown-item>
                      <b-dropdown-item @click="selectLanguage('es')">
                        <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                        Español (Spanish)
                      </b-dropdown-item>
                      <b-dropdown-item @click="selectLanguage('it')">
                        <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                        Italiano (Italian)
                      </b-dropdown-item>
                      <b-dropdown-item @click="selectLanguage('nl')">
                        <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                        Nederlands (Dutch)
                      </b-dropdown-item>
                      <b-dropdown-item @click="selectLanguage('pt')">
                        <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                        Português (Portuguese)
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                </div>  
                <b-carousel
                  v-if="winery.image_files.length >0"
                  id="carousel-fade"
                  slide = true
                  :interval="4000"
                  controls
                  background="#fffff0"
                  img-width="300"
                  img-height="200"
                  fade
                  style="text-shadow: 1px 1px 2px #333;"
                > 
                  <b-carousel-slide v-for="image_file in winery.image_files" v-bind:key="image_file.dataURL">
                    <template v-slot:img>
                      <img
                        class="d-block img-fluid w-100"  
                        width="300"
                        height="200"
                        v-bind:src="image_file.dataURL"
                      >
                    </template>
                  </b-carousel-slide>
                </b-carousel>
                <div v-else>
                  <b-img
                    style="width:100%"
                    :src="require('@/assets/img/winery-picture.png')"
                  ></b-img>
                </div>
              </div>
              <div class="over">
                <b-row>
                  <b-col>
                    <h1 class="preview-title">{{winery.name}}</h1>
                    <div v-if="isTranslating">
                      <p class="preview-text" style="font-weight: bold;">{{ translate("translating") }} ...</p>
                      <p class="preview-text">{{winery.description}}</p>
                    </div>
                    <div v-else>
                      <p class="preview-text">{{translatedText}}</p>
                    </div>
                  </b-col>
                </b-row>
                <br> 
                <hr>
                <p class="preview-subtitle" style="text-align:right!important">{{ translate("our wines") }}</p>
                <b-row class="justify-content-center" style="margin:0"> 
                  <b-col
                    v-for="(wine, index) in wines"
                    v-bind:item="wine"
                    v-bind:index="index"
                    v-bind:key="wine._id" 
                    class="w-tile m-2 d-inline-flex justify-content-center w-cursor-click"
                    xs="12" sm="6" md="4" lg="4" xl="3"
                    style ="display:block; min-width:300px"
                    v-on:click="$router.push({path:'/Wine', query: {wine_id:wine._id }})"
                  > 
                    <b-row style="width:100%">
                      <b-col cols="3" class="justify-content-center" style="height:100%;width:auto;padding:0">
                        <b-img center v-if="wine.image_files[0]"
                          style="height:100%;width:auto;position:absolute;right:0px"
                          v-bind:src="wine.image_files[0].dataURL" 
                        ></b-img>
                        <b-img center v-else
                          style="height:100%;width:auto;position:absolute;right:0px"
                          :src="require('@/assets/img/bottle.png')"
                        ></b-img>
                      </b-col>
                      <b-col cols="9" class="d-table-cell">
                        <p class="w-title">{{wine.name}}</p>
                        <p class="w-subtitle" v-if="wine.type">{{wine.type}}</p>
                        <hr style="margin:5px 0 5px 0">
                        <p class="w-text" v-if="wine.appellation">{{wine.appellation}}</p>
                        <p class="w-text" v-if="wine.classification">{{wine.classification}}</p>
                        <p class="w-smalltext" v-if="wine.grapes">{{wine.grapes}}</p>
                      </b-col>
                    </b-row>
                  
                  </b-col>
                </b-row>
                <hr>
                <b-row>
                  <b-col>
                    <p class="preview-text text-center">{{winery.address1}}</p>
                    <p class="preview-text text-center">{{winery.address2}}</p>
                    <p class="preview-text text-center">{{winery.zip}} {{winery.city}}</p>
                    <p class="preview-text text-center">{{winery.country}}</p>
                    <p class="preview-text text-center">{{winery.phone}}</p>
                    <p class="preview-text text-center">{{winery.email}}</p>
                  </b-col>           
                </b-row> 
                <hr>
                <b-row class="justify-content-center">
                  <p class="w-cursor-click" v-if="winery.webpage !='' && typeof winery.webpage != 'undefined'" v-on:click="gotoWebpage()" style="float: left;margin: 10px;font-size:11px"><img :src="require('@/assets/img/web.jpg')" height="20px" width="20px"><b><span style="color: rgb(114,118,121)"> website</span></b></p>
                  <p class="w-cursor-click" v-if="winery.facebook !='' && typeof winery.facebook != 'undefined'" v-on:click="gotoFacebook()" style="float: left;margin: 10px;font-size:11px"><img :src="require('@/assets/img/facebook.jpg')" height="20px" width="20px"><b><span style="color: rgb(114,118,121)"> facebook</span></b></p>
                  <p class="w-cursor-click" v-if="winery.instagram != '' && typeof winery.instagram != 'undefined'" v-on:click="gotoInstagram()"  style="float: left;margin: 10px;font-size:11px"><img :src="require('@/assets/img/instagram.jpg')" height="20px" width="20px"><b><span style="color: rgb(114,118,121)"> instagram</span></b></p>
                  <p class="w-cursor-click" v-if="winery.twitter != '' && typeof winery.twitter != 'undefined'" v-on:click="gotoTwitter()" style="float: left;margin: 10px;font-size:11px"><img :src="require('@/assets/img/twitter.jpg')" height="20px" width="20px"><b><span style="color: rgb(114,118,121)"> twitter</span></b></p>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div v-else>
        <br>
        <b-row style="height:40vh;margin:0" class="welcome-picture">
          <b-col cols="1" sm="2">
          </b-col>
          <b-col cols="10" sm="8" style="height:100%">
            <div class="welcome-overlay">
              <h1 class="main-title"><span style="color: rgb(195,147,130)">WYNE</span>MAKER</h1>
              <p class="main-subtitle">PAGE NOT FOUND</p>
            </div> 
          </b-col>
        </b-row> 
        <br>
        <br>
        <br>
        <b-row>
          <b-col cols="1" sm="2">
          </b-col>
          <b-col cols="10" sm="8" class="text-right"> 
            <b-button v-on:click="gotoStart()" class="w-button-green">start</b-button>
          </b-col>
        </b-row>
      </div>  
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';

  import {wordlist,translate_word} from '../assets/js/translate.js';
  import Translate from '../TranslateAI.js';  

  import makeWebname from '../assets/js/makeWebname.js';
  import Winery_from_Webname from '../Winery_from_Webname.js';

  import Wineries from '../Wineries.js'
  import Wines from '../Wines.js'
  
  export default {
    name: 'PageNotFound',
    computed : {
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },        
    },
    watch: {
      currentLanguage: function () {
        this.scheduleTranslateText();
      }
    },
    data() {
      return {
        debug: false,

        isLoading : true,

        wineryExists: false,
        webname:'',
        winery_id:0,

        winery: {
          name : '',
          description: '',
          webpage: '',
          image_files:[],
          wine_ids:[],
        },
        wines:[],

        translatedText: '',
        isTranslating: false, 
        _translateTimer: null,
        _translateCache: {},

        language:'en',
      }
    },
    async mounted() {
      let local_debug = false
      this.webname = this.$route.path.split('/')[1]
      let challenge = {"webname": this.webname};

      await Winery_from_Webname.getToken(challenge)
      .then(response => {
        if (response === 0) {
          if (local_debug || this.debug) console.log("PageNotFound in mounted: winery with webname ", this.webname, " has no id and does NOT exists in DB");
          this.wineryExists = false;
        } else {
          if (local_debug || this.debug) console.log("PageNotFound in mounted: winery with webname ", this.webname, " has id = ", response, " and exists in DB");
          this.wineryExists = true;
          this.winery_id = response;
        }
      })
      .catch(error => {
        this.wineryExists = true;
        if (local_debug || this.debug) console.log("PageNotFound in mounted: await Winery_from_Webname.getToken - ", error);
      })

      if (this.wineryExists) { 
        // alert("BINGO "+ this.winery_id)
        // this.$router.push({path:'/Winery/Public', query: {winery_id:this.winery_id }} );
     
        await Wineries.getone(this.winery_id)
        .then(response=>{
          this.winery = response;
          delete this.winery._id;
          if (local_debug || this.debug) console.log("PageNotFound in mounted: Winery "+ this.winery.name + " succesfully fetched from DB");
          document.title = this.winery.name
        })
        .catch(error=>{
          if (local_debug || this.debug) console.log("PageNotFound in mounted: catch await Wineries.getone ERROR : ", error);
        })

        if (typeof this.winery.wine_ids === "undefined" || this.winery.wine_ids === null) {
          this.winery.wine_ids = [];
        }
        for (var i=0; i < this.winery.wine_ids.length; i ++) {
          if (typeof this.winery.wine_ids[i] != "undefined" && this.winery.wine_ids[i] != null) {
            await Wines.getone(this.winery.wine_ids[i])
            .then(response=> {
              this.wines.push(response)
              if (local_debug || this.debug) console.log('PageNotFound in mounted : Wine with id= ', this.winery.wine_ids[i], ' succesfully fetched from DB with wine ', this.wines[i])
            })
            .catch(error=>{
              if (local_debug || this.debug) console.log('PageNotFound in mounted : catch await Wines.getone ERROR : ' + error);
            })
          } else {
            if (local_debug || this.debug) console.log('PageNotFound in mounted : ERROR wine_ids[',i,'] = ', this.winery.wine_ids[i]);
          }
        }
     }

      let language = Cookies.get('wynelover.language')
      if (typeof language == "undefined") {
        language = "en"
        if (local_debug || this.debug) console.log("Login.mounted: cookie NOT found wynelover.language = ", language)
      } else {
        if (local_debug || this.debug) console.log("Login.mounted: cookie found wynelover.language = ", language)
      }
      this.selectLanguage(language)

      this.scheduleTranslateText()

      this.isLoading = false
    },
    methods: {
      gotoStart() {
        this.$router.push({path:'/'});
      },
      gotoWebpage() {
        if (this.winery.webpage.substr(0,4) != "http") {
          this.winery.webpage = "http://" + this.winery.webpage
        }
        window.open(this.winery.webpage, '_blank');
      },
      gotoFacebook() {
        if (this.winery.facebook.substr(0,4) != "http") {
          this.winery.facebook = "http://" + this.winery.facebook
        }
        window.open(this.winery.facebook, '_blank');
      },
      gotoInstagram() {
        if (this.winery.instagram.substr(0,4) != "http") {
          this.winery.instagram = "http://" + this.winery.instagram
        }
        window.open(this.winery.instagram, '_blank');
      },
      gotoTwitter() {
        if (this.winery.twitter.substr(0,1) == "@") {
          this.winery.twitter = "https://twitter.com/" + makeWebname(this.winery.twitter)
        }
        window.open(this.winery.twitter, '_blank');
      },

      /* WyneMaker in multiple languages using Dictionary*/
      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("Login.selectLanguage: START");
        this.language = language
        this.$store.commit('setLanguage',language)

        Cookies.set('wynelover.language', language, { expires: 365 });
        if (local_debug || this.debug) console.log("Login.selectLanguage: language set to ", language);

        if (local_debug || this.debug) console.log("Login.selectLanguage: STOP");
      }, 

      translate(string) {
        // console.log("TMP string: ", string, " language: ", this.currentLanguage, " translation: ",translate_word(string, this.currentLanguage) )
        return translate_word(string, this.currentLanguage);
      },      

       /* WyneMaker in multiple languages using ChatGPT */
      scheduleTranslateText() {
        let local_debug = false

        if (!this._translateCache) this._translateCache = {};

        const textRaw = this.winery.description || '';
        const text = textRaw.trim();
        const target = this.currentLanguage;

          if (local_debug || this.debug) {
            console.log("scheduleTranslateText: START", {
              currentLanguage: target,
              textLen: textRaw.length,
              textTrimLen: text.length,
              hasTimer: !!this._translateTimer,
              cacheSize: this._translateCache ? Object.keys(this._translateCache).length : 0,
            });
          }      

        // Always show original immediately
        this.translatedText = textRaw;

        if (!text) {
          if (local_debug || this.debug) console.log("scheduleTranslateText:  skip: empty text");
          this.isTranslating = false;
          return;
        }
        if (!target) {
          if (local_debug || this.debug) console.log("scheduleTranslateText:  skip: empty target");
          this.isTranslating = false;
          return;
        }

        // ✅ SHOW "translating…" while waiting
        this.isTranslating = true;

        if (this._translateTimer) {
          clearTimeout(this._translateTimer);
          if (local_debug || this.debug) console.log("scheduleTranslateText:  cleared previous timer");
        }

        this._translateTimer = setTimeout(() => {
          if (local_debug || this.debug) console.log("scheduleTranslateText:  firing translateTextNow()", { target, textTrimLen: text.length });
          this.translateTextNow(text, target);
        }, 350);

        if (local_debug || this.debug) console.log("scheduleTranslateText:  STOP - timer scheduled (350ms)");
      },
      async translateTextNow(text, target) {
        let local_debug = false

        if (!this._translateCache) this._translateCache = {};

        const cacheKey = `${target}||${text}`;

        if (local_debug || this.debug) {
          console.log("translateTextNow: START", {
            target,
            textTrimLen: text.length,
            cacheKeyPreview: cacheKey.slice(0, 80) + (cacheKey.length > 80 ? "…" : ""),
          });
        }

        // Cache hit
        if (Object.prototype.hasOwnProperty.call(this._translateCache, cacheKey)) {
          if (local_debug || this.debug) console.log("translateTextNow:  cache HIT");
          this.translatedText = this._translateCache[cacheKey];
          this.isTranslating = false; // ✅ DONE
          return;
        }

        if (local_debug || this.debug) console.log("translateTextNow:  cache MISS -> calling API");

        try {
          const res = await Translate.translate({ text, target, tone: 'natural' });
          const out = res?.translatedText || text;

          const stillSameText = ((this.winery.description || '').trim() === text);
          const stillSameLang = (this.currentLanguage === target);

          if (stillSameText && stillSameLang) {
            this._translateCache[cacheKey] = out;
            this.translatedText = out;
            if (local_debug || this.debug) console.log("translateTextNow:  applied translation + cached");
          }
          else {
            if (local_debug || this.debug) console.log("translateTextNow:  NOT applied (text/lang changed while waiting)");
          }
        } catch (e) {
          const status = e?.response?.status;
          const data = e?.response?.data;
          const msg = e?.message;
          console.log("translateTextNow:  API ERROR", { status, msg, data, e });

          this.translatedText = this.winery.description || '';
        } finally {
          this.isTranslating = false; // ✅ ALWAYS clear
        }
      },


    }
  }
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
.welcome-picture {
    width:100%;
    height:auto;
    
    background-image: url("../assets/img/header.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:relative;
}
.welcome-overlay {
  position: relative;
  top: 10vh;
}

.over {
    position: relative;
    width:90%;
    top: -50px;
    left: 45%;
    z-index: 3;
    color: black;
    padding: 3% 15% 10% 10%;
    background-color:white;
    border-radius: 1%;
      -webkit-transform: translate3d(-50%,0,0);
         -moz-transform: translate3d(-50%,0,0);
          -ms-transform: translate3d(-50%,0,0);
           -o-transform: translate3d(-50%,0,0);
              transform: translate3d(-50%,0,0);
      -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.17);
       -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.17);
            box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.17);
}

.main-title {
  font-family: 'Segoe UI';
  font-size: 44px;
  font-weight: bolder;
  color: rgb(112,112,112);
}

.main-text {
  font-family: 'Segoe UI';
  font-size: 16px;
  color: rgb(112,112,112);
}

.w-picture{
  height: 200px;
  width: auto;
}
.w-detail {

}
.w-title {
  font-size: 18px;
  margin: 10px 0 0 0;
}

.w-subtitle {
  font-size:14px;
  margin:0.5vm;
}

.w-text {
  margin:0;
  font-size: 12px;
}

.w-smalltext {
  padding-top : 10px;
  font-size: 10px;
}

/* Language selector overlay */
.language {
  position: absolute;
  top: 12px;          /* distance from top of carousel */
  left: 24px;        /* move to left if you prefer */
  z-index: 10;        /* higher than carousel controls */
  pointer-events: auto;
}
</style> 